import {
  v2PwaBasePath,
  paymentsProjectBasePath,
  projectBasePathWithFolder,
  imgBaseUrl,
  clientPlatform,
  shouldHideCompleteLocationFlow,
} from "../config/apiEndpoints";
import store from "../store/index";
import {
  keyMapsAction,
  keyMapsMutation,
  keyMapsGetter,
} from "../helpers/storeKeys";
import { LoginStates, LoginStateStatus } from "../helpers/loginStateConstants";
import PageNames from "../config/pageNames";
import LocalStorageFunc from "./localStorageFunc";
import { EVENT_CLICK_OSBACK, EVENT_CLICK_PWABACK } from "./analyticsEvents";
import {
  OrderStatusCode,
  ORDER_STATUS_LONG_HISTORY,
  OrderStatusBgColor,
} from "./OrderStatusConstants";

import { PAYMENT_METHOD } from "./paymentConstants";

const tryJsonParse = (value, defaultValue = {}) => {
  let data;
  if (value === undefined || value === null || value === "null")
    return defaultValue;
  try {
    data = JSON.parse(value);
  } catch (e) {
    return defaultValue;
  }
  return data;
};

const randomnumber = (minimum = 100000000, maximum = 999999999) => {
  return Math.floor(Math.random() * (maximum - minimum, maximum + 1)) + minimum;
};

const categoryCounter = (data, productCategoryData) => {
  if (!!window.IntersectionObserver) {
    let observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (data.find((i) => entry.target.id == i.nodeId)) {
              store.commit(
                keyMapsMutation.UPDATE_SELECTED_MENU_ITEM,
                entry.target.id
              );
            } else {
              let x = productCategoryData.find(
                (i) => entry.target.id == i.nodeId
              );
              store.commit(
                keyMapsMutation.UPDATE_SELECTED_MENU_ITEM,
                x?.parentNodeId
              );
            }
          }
        });
      },
      {
        root: null,
        threshold: 0.5,
        rootMargin: "-50px 0px",
      }
    );
    store.commit(keyMapsMutation.SET_PRODUCT_OBSERVER, observer);
  }
};

const groupArrayOfObjectBykey = (array, key) => {
  return array?.reduce((result, currentValue) => {
    (result[currentValue[key]] = result[currentValue[key]] || []).push(
      currentValue
    );
    return result;
  }, {});
};

const getArrayFromObject = (obj) => {
  let arr = [];
  Object.entries(obj).forEach(([key, value]) => {
    let innerArr = [];
    Object.entries(value).forEach(([key2, value2]) => {
      innerArr.push(value2);
    });
    arr.push(innerArr);
  });
  return arr;
};

const getDateStringFromTimeStamp = (timestamp) => {
  if (!timestamp) {
    return "";
  }
  let date = new Date(timestamp);
  const day = date.getDate();
  const month = date
    .toLocaleString("default", {
      month: "long",
    })
    .slice(0, 3);
  const year = date.getFullYear();
  return day + " " + month + ", " + year;
};

const getTimeFromTimeStamp = (timestamp) => {
  const date = new Date(timestamp);
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const formattedTime = `${hours}:${minutes}`;
  return formattedTime;
};

const formatTimestampOffer = (timestamp) => {
  const totalSeconds = Math.floor(timestamp / 1000);
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return `${days}d:${hours}h:${minutes}m:${seconds}s`;
};

const isSeparateMenuVariant = () => {
  if ([PageNames.HONGS_MENU_PAGE].includes(getCurrentStoreFolder())) {
    return true;
  }
  return false;
};

const typeCheckProductItem = (item) => {
  return;
};

const mergeDeep = (...objects) => {
  const isObject = (obj) => obj && typeof obj === "object";

  return objects.reduce((prev, obj) => {
    Object.keys(obj).forEach((key) => {
      const pVal = prev[key];
      const oVal = obj[key];

      if (Array.isArray(pVal) && Array.isArray(oVal)) {
        prev[key] = oVal;
      } else if (isObject(pVal) && isObject(oVal)) {
        prev[key] = mergeDeep(pVal, oVal);
      } else {
        prev[key] = oVal;
      }
    });

    return prev;
  }, {});
};

const getProductSkuId = (item) => {
  return item?.parentSkuId || item?.skuId;
};

const getSkuId = (item) => {
  return item?.selectedVariant?.skuId || "";
};

const getComboSkuId = (item) => {
  return item?.skuId;
};

const getParentSkuId = (item) => {
  return item?.parentSkuId;
};

const getProductCurrentPrice = (item) => {
  return (
    item?.selectedVariant?.price?.currentPrice || item?.price?.currentPrice || 0
  );
};

const getProductType = (item) => {
  return item.productMasterUID ? "singleProduct" : "comboProduct";
};

const getDomain = () => {
  let domain = window.location.host.toString();

  let index = domain.indexOf(".");

  domain = domain.substr(index, domain.length - 1);

  return domain;
};

const getCookie = (c_name) => {
  var i,
    x,
    y,
    ARRcookies = document.cookie.split(";");

  for (i = 0; i < ARRcookies.length; i++) {
    x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));

    y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);

    x = x.replace(/^\s+|\s+$/g, "");

    if (x == c_name) {
      return unescape(y);
    }
  }
};

const setCookie = (name, value, days, domain) => {
  var expires = "";

  if (days) {
    var date = new Date();

    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);

    expires = "; expires=" + date.toUTCString();
  }

  document.cookie =
    name +
    "=" +
    (value || "") +
    ";domain=" +
    (domain || ".monsterindia.com") +
    expires +
    "; path=/";
};

const deleteCookie = (name, domain) => {
  if (name) {
    document.cookie =
      name +
      "=;expires=Thu,01 Jan 1970 00:00:01 UTC;path=/;domain=" +
      (domain || ".dominos.co.in");
  }
};

const getCurrentStoreFolder = () => {
  let link_rewrite = window._siteProps_?.link_rewrite;
  if (link_rewrite == "/") {
    link_rewrite = "";
  }

  return `/${link_rewrite || "store"}/`;
};

const checkWindowLocationIncludes = (partial) => {
  return (
    window.location.href.includes(partial) &&
    (window.location.href.includes(partial + "/") ||
      window.location.href.includes(partial + "?") ||
      !window.location.href.split(partial)[1])
  );
};

const getUrlQueryString = () => {
  let data = "";
  try {
    var url = window.location.href,
      retObject = {},
      parameters;
    if (url.indexOf("?") === -1) {
      return "";
    }
    url = url.split("?")[1];
    parameters = url.split("&");
    for (var i = 0; i < parameters.length; i++) {
      retObject[parameters[i].split("=")[0]] = parameters[i].split("=")[1];
    }

    data = "?";
    for (const [key, value] of Object.entries(retObject)) {
      if (key) {
        data = data + "&" + key + "=" + value;
      }
    }
  } catch (e) {
    data = "";
  }

  return data;
};

const areSetsEqual = (a, b) =>
  a.size === b.size && [...a].every((value) => b.has(value));

const getSearchableText = (text) => {
  return text?.trim()?.toLowerCase();
};

const scrollUptoTo = (elmId, topValMargin = 130) => {
  let el = document.getElementById(elmId);
  let top = el?.offsetTop;
  window.scrollTo({
    top: top - topValMargin,
    left: 100,
    behavior: "smooth",
  });
};

const gotoElement = ({ type = "CATEGORY", id = "" }) => {
  let shouldShowAllProductCategories =
    store.state.ProductItems.shouldShowAllProductCategories;
  if (shouldShowAllProductCategories) {
    switch (type) {
      case "CATEGORY":
        scrollUptoTo("element_catg_" + id);
        break;
      case "PRODUCT":
        scrollUptoTo("prod_id_" + id);
        break;
      default:
        scrollUptoTo("element_catg_" + id);
    }
  } else {
    store.commit(
      keyMapsMutation.UPDATE_SHOULD_SHOW_ALL_PRODUCT_CATEGORIES,
      true
    );
    setTimeout(() => {
      switch (type) {
        case "CATEGORY":
          scrollUptoTo("element_catg_" + id);
          break;
        case "PRODUCT":
          scrollUptoTo("prod_id_" + id);
          break;
        default:
          scrollUptoTo("element_catg_" + id);
      }
    }, 100);
  }
};

const getSitePropsVersion = () => {
  return window?._siteProps_?.props?.app_version
    ? "?ver=" + window?._siteProps_?.props?.app_version
    : "?ver=1.1.1";
};

const prepareImgPath = (url) => {
  if (url.indexOf("https:") != -1) {
    return url + getSitePropsVersion();
  } else {
    return imgBaseUrl + "/" + url + getSitePropsVersion();
  }
};

// @todo to be modified once catgory data contains images
const getProductImages = (imgArr, catg) => {
  let webp = {},
    jpg = {};
  for (let i = 0; i < imgArr?.length; i++) {
    if (imgArr[i].mediaSize == "Web" + catg) {
      webp = prepareImgPath(imgArr[i].mediaPath);
    } else if (imgArr[i].mediaSize == catg) {
      jpg = prepareImgPath(imgArr[i].mediaPath);
    }
  }
  if (Object.keys(webp).length > 0) {
    return webp;
  } else {
    return jpg;
  }
};

const getFormattedDateAdvanceOrder = (date) => {
  if (date == "") {
    return "";
  }
  let dateString = new Date(date);
  let formattedDate = "";
  let weeks = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  let months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  let weekDay = weeks[dateString.getDay()];
  let month = months[dateString.getMonth()];
  let day = dateString.getDate();
  let year = dateString.getFullYear();
  dateString = weekDay + ", " + day + " " + month + ", " + year;
  return dateString;
};

const getFormattedTimeAdvanceOrder = (time) => {
  if (time == "") {
    return "";
  }
  let { hours, minutes } = time;
  var ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? "0" + minutes : minutes;
  hours = hours < 10 ? "0" + hours : hours;
  var strTime = hours + ":" + minutes + " " + ampm;
  return strTime;
};

const getFormattedDateTimeAdvanceOrder = (date, time) => {
  return date.substring(date.indexOf(",") + 1).trim() + " " + time;
};

const getCartDataInMenuServiceFormat = (cartItems) => {
  let menuServiceItems = { productDefinitions: [], comboDefinitions: [] };

  for (const [key, value] of Object.entries(cartItems)) {
    if (value.length > 0) {
      cartItems[key]?.map((productItem) => {
        if (productItem.comboUID) {
          delete productItem.selectedComboVariant;
          menuServiceItems["comboDefinitions"].push(productItem);
          productItem?.customizationOptions?.map((customizationOption) => {
            customizationOption?.items?.map((item) => {
              menuServiceItems["productDefinitions"].push(item.productDetails);
            });
          });
        } else if (productItem.productMasterUID) {
          delete productItem.selectedVariant;
          menuServiceItems["productDefinitions"].push(productItem);
        }
        return productItem;
      });
    }
  }
  return menuServiceItems;
};

const isDesktop = () => {
  if (clientPlatform == "Web") {
    return true;
  } else {
    return false;
  }
};

// append redirect url
const sendToLoginScreen = (redirectUrl = "") => {
  store.commit(keyMapsMutation.UPDATE_LOADING_STATE, true, {
    root: true,
  });
  setTimeout(
    () =>
      store.commit(keyMapsMutation.UPDATE_LOADING_STATE, false, {
        root: true,
      }),
    5000
  );
  if (clientPlatform == "Web") {
    store.commit(keyMapsMutation.UPDATE_SHOW_WELCOME_SCREEN_ON_PAGELOAD, true);
  } else if (redirectUrl.length) {
    addSelectedRedirectUrl("/login", redirectUrl);
  } else {
    addRedirectUrl("/login");
  }
};

const sendToSearchScreen = () => {
  store.commit(keyMapsMutation.UPDATE_LOADING_STATE, true, {
    root: true,
  });
  setTimeout(
    () =>
      store.commit(keyMapsMutation.UPDATE_LOADING_STATE, false, {
        root: true,
      }),
    5000
  );
  let url = projectBasePathWithFolder + "/search/" + LocalStorageFunc.storeId();
  window.location.href = addQueryParams(url);
  return;
};

const sendToLocationScreen = (paramObj = {}) => {
  if (paramObj?.changeTriggerFromDineinTwy) {
    store.commit(keyMapsMutation.UPDATE_LOADING_STATE, true, {
      root: true,
    });
    let url = window.location.href;
    url = addUpdateParam(
      url,
      "changeTriggerFromDineinTwy",
      paramObj?.changeTriggerFromDineinTwy
    );
    window.location.href = addQueryParams(url);
  } else {
    store.commit(keyMapsMutation.UPDATE_LOADING_STATE, true, {
      root: true,
    });
    addRedirectUrl("/location");
  }
  return;
};

const sendToCartScreen = () => {
  store.commit(keyMapsMutation.UPDATE_LOADING_STATE, true, {
    root: true,
  });
  let url =
    projectBasePathWithFolder + "/cart-unified/" + LocalStorageFunc.storeId();
  window.location.href = addQueryParams(url);
  return;
};

const addUpdateParam = (url, param, paramValue) => {
  if (url.indexOf("?") !== -1) {
    let queryParams = {};
    let queryUrl = url.split("?");
    let parameters = queryUrl[1].split("&");
    for (var i = 0; i < parameters.length; i++) {
      queryParams[parameters[i].split("=")[0]] = parameters[i].split("=")[1];
    }
    // add/update the param
    queryParams[param] = paramValue;

    let _ = "?";
    for (const [key, value] of Object.entries(queryParams)) {
      if (key) {
        _ = _ + "&" + key + "=" + value;
      }
    }
    return queryUrl[0] + _;
  }
  url = url + "?&" + param + "=" + paramValue;
  return url;
};

const sendToMenuScreen = (category = "") => {
  store.commit(keyMapsMutation.UPDATE_LOADING_STATE, true, {
    root: true,
  });
  if (category) {
    let url = projectBasePathWithFolder + "/menu/" + LocalStorageFunc.storeId();
    url = addUpdateParam(url, "scrollTo", category);
    window.location.href = addQueryParams(url);
  } else {
    let url = projectBasePathWithFolder + "/menu/" + LocalStorageFunc.storeId();
    window.location.href = addQueryParams(url);
  }
  return;
};

const sendToHomepageScreen = () => {
  store.commit(keyMapsMutation.UPDATE_LOADING_STATE, true, {
    root: true,
  });
  let url = projectBasePathWithFolder + "/store/" + LocalStorageFunc.storeId();
  window.location.href = addQueryParams(url);
  return;
};
const sendToOffersScreen = () => {
  store.commit(keyMapsMutation.UPDATE_LOADING_STATE, true, {
    root: true,
  });
  if (clientPlatform == "Web") {
    store.commit(keyMapsMutation.UPDATE_INIT_OFFER_LISTING_WRAPPER, true);
  } else {
    let url = projectBasePathWithFolder + "/offers";
    window.location.href = addQueryParams(url);
    return;
  }
};

const addRedirectUrl = (url) => {
  store.commit(keyMapsMutation.UPDATE_LOADING_STATE, true, {
    root: true,
  });
  if (!window.location.pathname.includes(url)) {
    let searchQuery = window.location.search;
    let params = new URLSearchParams(searchQuery);
    let redirectUrl = params.get("redirectUrl");
    if (searchQuery.length && redirectUrl) {
      let finalUrl =
        projectBasePathWithFolder + url + "?redirectUrl=" + location.pathname;
      window.location.href = addQueryParams(finalUrl);
    } else {
      let finalUrl =
        projectBasePathWithFolder + url + "?redirectUrl=" + location.href;
      window.location.href = addQueryParams(finalUrl);
    }
  } else {
    window.location.reload();
  }
  return;
};

const addSelectedRedirectUrl = (url = "", redirectUrl = "") => {
  store.commit(keyMapsMutation.UPDATE_LOADING_STATE, true, {
    root: true,
  });
  let finalUrl =
    projectBasePathWithFolder +
    url +
    "?redirectUrl=" +
    projectBasePathWithFolder +
    redirectUrl;
  window.location.href = addQueryParams(finalUrl);

  return;
};

const redirectToPaymentPage = () => {
  store.commit(keyMapsMutation.UPDATE_LOADING_STATE, true, {
    root: true,
  });
  window.location.href = paymentsProjectBasePath + "/payment";
  return;
};
const sendToOrderHistory = () => {
  store.commit(keyMapsMutation.UPDATE_LOADING_STATE, true, {
    root: true,
  });
  redirectToLinkRewrite("/order-history");
};

const sendToMyAddressPage = () => {
  store.commit(keyMapsMutation.UPDATE_LOADING_STATE, true, {
    root: true,
  });
  redirectToLinkRewrite("/my-addresses");
};

const sendToTnC = () => {
  store.commit(keyMapsMutation.UPDATE_LOADING_STATE, true, {
    root: true,
  });
  addRedirectUrl("/content/tnc");
};

const sendToHelpPage = () => {
  store.commit(keyMapsMutation.UPDATE_LOADING_STATE, true, {
    root: true,
  });
  addRedirectUrl("/content/contact-us");
};

const sendToOrderTracking = (transactionId = "") => {
  store.commit(keyMapsMutation.UPDATE_LOADING_STATE, true, {
    root: true,
  });
  if (transactionId) {
    redirectToLinkRewrite("/order-tracking?transactionId=" + transactionId);
  } else redirectToLinkRewrite("/order-tracking");
};

const updateOfferUrl = () => {
  window.history.replaceState(
    null,
    null,
    projectBasePathWithFolder + "/offers"
  );
};

const redirectToLinkRewrite = (
  linkRewrite,
  baseUrl = projectBasePathWithFolder
) => {
  store.commit(keyMapsMutation.UPDATE_LOADING_STATE, true, {
    root: true,
  });
  if (!window.location.pathname.includes(linkRewrite)) {
    let url = baseUrl + linkRewrite;
    window.location.href = addQueryParams(url);
  } else {
    window.location.reload();
  }
  return;
};

const reloadPage = () => {
  window.location.reload();
  return;
};

const sendToThankYouScreen = (transactionId = "") => {
  redirectToLinkRewrite(
    "/thankYou?transactionId=" + transactionId,
    projectBasePathWithFolder
  );
};

const redirectToHomeOrRedirectUrl = (updateParam = []) => {
  store.commit(keyMapsMutation.UPDATE_LOADING_STATE, true, {
    root: true,
  });
  let searchQuery = window.location.search;
  let params = new URLSearchParams(searchQuery);
  let redirectUrl = params.get("redirectUrl");
  if (updateParam.length) {
    if (searchQuery.length && redirectUrl && LocalStorageFunc.isLoggedIn()) {
      let newUrl = addQueryParams(redirectUrl);
      updateParam.map((param) => {
        newUrl = addUpdateParam(newUrl, param.name, param.value);
      });
      window.location.href = newUrl;
    } else {
      let url =
        projectBasePathWithFolder + "/store/" + LocalStorageFunc.storeId();
      let newUrl = addQueryParams(url);
      updateParam.map((param) => {
        newUrl = addUpdateParam(newUrl, param.name, param.value);
      });
      window.location.href = newUrl;
    }
  } else {
    if (searchQuery.length && redirectUrl && LocalStorageFunc.isLoggedIn()) {
      window.location.href = addQueryParams(redirectUrl);
    } else {
      let url =
        projectBasePathWithFolder + "/store/" + LocalStorageFunc.storeId();
      window.location.href = addQueryParams(url);
    }
  }
};

const redirectToOrderHistoryOrRedirectUrl = () => {
  store.commit(keyMapsMutation.UPDATE_LOADING_STATE, true, {
    root: true,
  });
  let searchQuery = window.location.search;
  let params = new URLSearchParams(searchQuery);
  let redirectUrl = params.get("redirectUrl");
  if (searchQuery.length && redirectUrl) {
    window.location.href = addQueryParams(redirectUrl);
  } else {
    redirectToLinkRewrite("/order-history");
  }
};

const isRedirectedFromCart = () => {
  let searchQuery = window.location.search;
  let params = new URLSearchParams(searchQuery);
  let redirectUrl = params.get("redirectUrl");
  return searchQuery.length && redirectUrl.includes("/cart") ? true : false;
};

const isNoRedirectTrue = () => {
  let queryParams = getQueryFromUrl();
  if (queryParams["noredirect"]) {
    return true;
  } else return false;
};

const addQueryParams = (url) => {
  let currentUrl = window.location.href;
  let currentQueryParams = getQueryFromUrl(currentUrl);
  let queryParams = getQueryFromUrl(url);
  // in case both have query parameters
  if (currentUrl.indexOf("?") !== -1) {
    if (currentQueryParams["redirectUrl"]) {
      delete currentQueryParams["redirectUrl"];
    }
    let newQuery = getQueryFromQueryParameters(
      Object.assign({}, currentQueryParams, queryParams)
    );
    if (newQuery.length > 0) {
      return url.split("?")[0] + "?" + newQuery;
    } else {
      return url.split("?")[0];
    }
  } else {
    return url;
  }
};

const getQueryFromQueryParameters = (params) => {
  let paramKeys = Object.keys(params);
  let query = "";
  paramKeys.map((item, index) => {
    if (index !== paramKeys.length - 1 && params[item] !== undefined) {
      query = query + item + "=" + params[item] + "&";
    } else if (params[item] !== undefined) {
      query = query + item + "=" + params[item];
    }
  });
  return query;
};

const getStoreIdFromUrl = () => {
  if (window.location.pathname.includes("/store/")) {
    let storeId = window.location.pathname.split("/store/")[1];
    return storeId;
  }
  return "";
};
const isCurrentlyAtUrl = (url) => {
  return window.location.pathname.split("?")[0].includes(url);
};

const checkFromAddressPage = () => {
  console.log("refferer", document.referrer);
};

const checkTriggerLocationScreenForAddEditAddress = () => {
  if (
    LocalStorageFunc.getAddAddressEnable() ||
    Object.keys(LocalStorageFunc.getEditAddress()) != 0
  ) {
    return true;
  }
  return false;
};

const checkEditAddressOnLocation = () => {
  if (Object.keys(LocalStorageFunc.getEditAddress()) != 0) {
    return true;
  }
};

const removeAddEditAddressFromStorage = () => {
  LocalStorageFunc.unsetKey("addAddressEnable");
  LocalStorageFunc.unsetKey("editAddress");
  LocalStorageFunc.unsetKey("locationChangedAddress");
};

const getAddressObject = (google_address_components) => {
  var ShouldBeComponent = {
    area1: ["ADMINISTRATIVE_AREA_LEVEL_1"],
    area2: ["ADMINISTRATIVE_AREA_LEVEL_2"],
    area3: ["ADMINISTRATIVE_AREA_LEVEL_3"],
    city: ["LOCALITY"],
    country: ["COUNTRY"],
    district: ["SUBLOCALITY"],
    locality: ["LOCALITY"],
    postalCode: ["POSTAL_CODE"],
    route: ["ROUTE"],
    state: ["ADMINISTRATIVE_AREA_LEVEL_1"],
    subLocality: ["SUBLOCALITY"],
  };

  var googleAddressObj = {
    area1: "",
    area2: "",
    area3: "",
    city: "",
    country: "",
    district: "",
    locality: "",
    latitude: google_address_components?.geometry?.location?.lat || 0,
    longitude: google_address_components?.geometry?.location?.lng || 0,
    postalCode: "",
    route: "",
    state: "",
    subLocality: "",
  };
  google_address_components?.addressComponents.forEach((component) => {
    for (var shouldBe in ShouldBeComponent) {
      if (ShouldBeComponent[shouldBe].indexOf(component.types[0]) !== -1) {
        if (shouldBe === "country") {
          googleAddressObj[shouldBe] = component.shortName;
        } else {
          googleAddressObj[shouldBe] = component.longName;
        }
      }
    }
  });
  let addressObj = {
    address_component: googleAddressObj,
    address_id: 0,
    address_status: "A",
    address_type: "",
    area_level0: "",
    area_level1: "",
    area_level2: "",
    building_number: "",
    city: "",
    city_region: "",
    clientType: "",
    country: "",
    customer_address_name: "",
    discovery_source: "",
    email: "",
    first_name: "",
    formatted_address: "",
    is_default: true,
    last_name: "",
    latitude: googleAddressObj?.latitude || 0,
    legacy_id: "",
    longitude: googleAddressObj?.longitude || 0,
    mobile_no: LocalStorageFunc.getMobileNumber() || "",
    postalCode: "",
    sort_order: 0,
    state: "",
    store_code: "",
    street_name: "",
    tenant_id: 0,
    user_id: LocalStorageFunc.getUserId() || "",
  };
  return addressObj;
};

const isStoreUrlCacheEligible = () => {
  let _ = LocalStorageFunc.getComputedLocationData();
  if (!_?.address_alias) {
    return false;
  }
  if (shouldHideCompleteLocationFlow) {
    return window.location.href.includes(
      getCurrentStoreFolder() + LocalStorageFunc.storeId()
    );
  }
  return (
    LocalStorageFunc.getIsStoreIdCacheEligible() &&
    window.location.href.includes(
      getCurrentStoreFolder() + LocalStorageFunc.storeId()
    )
  );
};

const getAdvanceCardDateStringFromTimeStamp = (timestamp) => {
  if (timestamp == "") {
    return "";
  }
  timestamp = timestamp * 1000;
  let date = new Date(timestamp);
  const day = date.getDate();
  const month = date.toLocaleString("default", {
    month: "long",
  });
  const year = date.getFullYear();
  return day + " " + month.substring(0, 3) + " " + year;
};

const getAdvanceCardTimeStringFromTimeStamp = (timestamp) => {
  if (timestamp == "") {
    return "";
  }
  timestamp = timestamp * 1000;
  let time = new Date(timestamp);
  //console.log('time',time);
  let hours = time.getHours();
  let minutes = time.getMinutes();
  var ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? "0" + minutes : minutes;
  hours = hours < 10 ? "0" + hours : hours;
  var strTime = hours + ":" + minutes + " " + ampm;
  return strTime;
};

const getQueryFromUrl = (url = window.location.href) => {
  var retObject = {};
  try {
    var parameters;
    if (url.indexOf("?") === -1) {
      return {};
    }
    url = url.split("?")[1];
    parameters = url.split("&");
    for (var i = 0; i < parameters.length; i++) {
      retObject[parameters[i].split("=")[0]] = parameters[i].split("=")[1];
    }
  } catch (e) {
    return {};
  }

  return retObject;
};

const asyncCallWithTimeout = async (asyncPromise, timeLimit) => {
  let timeoutHandle;

  const timeoutPromise = new Promise((_resolve, reject) => {
    timeoutHandle = setTimeout(() => {
      reject(new Error("Async call timeout limit reached"));
    }, timeLimit);
  });

  return Promise.race([asyncPromise, timeoutPromise]).then((result) => {
    clearTimeout(timeoutHandle);
    return result;
  });
};

const getDeviceType = (userAgent) => {
  let deviceType = "desktop";
  if (/mobi|android/i.test(userAgent?.toLowerCase() || "")) {
    deviceType = "mobile";
  } else if (/ipad|tablet/i.test(userAgent?.toLowerCase() || "")) {
    deviceType = "tablet";
  }
  return deviceType;
};

const getHamburgerItemIndex = (item, menuGroup) => {
  let idx = 0;
  let found = -1;
  menuGroup?.map((menu) => {
    menu?.map((data) => {
      if (item?.name == data?.name) {
        found = idx;
      }
      idx++;
    });
  });
  return found;
};

const getTimePrefixWith = (userId = "") => `${new Date().getTime()}-${userId}`;

const osBackButtonFunc = (
  var1 = window?.performance?.navigation?.type,
  var2 = window?.performance?.navigation?.TYPE_BACK_FORWARD
) => {
  let flag;
  if (var1 === undefined || var2 === undefined) {
    flag = false;
  } else {
    flag = var1 === var2;
  }

  if (flag) {
    EVENT_CLICK_OSBACK();
  }
};

const appBackButtonFunc = () => {
  EVENT_CLICK_PWABACK();
};

const getInlineNotificationObjectForClientMsg = (obj) => {
  return {
    id: obj?.id || -1,
    actionUrl: obj?.actionUrl || "",
    closable: obj?.closable || "1",
    placement: obj?.placement || "top",
    displayAs: obj?.displayAs || "display",
    title: obj?.title || "store is offline",
    actionLabel: obj?.actionLabel || "",
    frequency: obj?.frequency || "DAILY",
    message: obj?.message || "bottom",
    subTitle: obj?.subTitle || "bottom",
    page: obj?.page || "",
  };
};
const convertArrayToObject = (arr) => {
  return arr.reduce((result, current) => {
    // loop over all the key-value pairs in the current object
    Object.entries(current).forEach(([key, value]) => {
      // add the key-value pair to the result object
      result[key] = value;
    });

    // return the result object for the next iteration
    return result;
  }, {});
};

const formatAMPM = (time) => {
  const date = new Date(time);
  let hours = date.getHours();
  let minutes = date.getMinutes();
  const ampm = hours >= 12 ? "pm" : "am";
  hours %= 12;
  hours = hours || 12;
  minutes = minutes < 10 ? `0${minutes}` : minutes;
  hours = +hours < 10 ? `0${hours}` : hours;
  const strTime = `${hours}:${minutes} ${ampm.toUpperCase()}`;
  return strTime;
};

const getAdvanceEpochConvertFormat = (day, time) => {
  let timeDateFormat;
  let today;
  let tomorrow;

  if (day === "Today") {
    today = new Date();
    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0"); // January is 0!
    const yyyy = today.getFullYear();

    today = `${mm}/${dd}/${yyyy}`;
    timeDateFormat = `${today} ${time}`;
  } else if (day === "Tomorrow") {
    tomorrow = new Date();
    tomorrow.setDate(new Date().getDate() + 1);
    const dd = String(tomorrow.getDate()).padStart(2, "0");
    const mm = String(tomorrow.getMonth() + 1).padStart(2, "0"); // January is 0!
    const yyyy = tomorrow.getFullYear();

    tomorrow = `${mm}/${dd}/${yyyy}`;
    timeDateFormat = `${tomorrow} ${time}`;
  } else {
    today = day;
    const dd = String(today.substring(0, 2));
    const mon = String(today.substring(3));
    const mm = today.indexOf(mon) + 1;
    const yyyy = new Date().getFullYear();
    today = `${mm}/${dd}/${yyyy}`;
    timeDateFormat = `${today} ${time}`;
  }
  return timeDateFormat;
};

const getAddressAlias = (
  stores,
  coords = LocalStorageFunc.getLastLocationNewOrLastLocationNewForIp()[0]
    ?.location || ""
) => {
  let footerAddress =
    LocalStorageFunc.getLastLocationNewOrLastLocationNewForIp()[0]?.recent
      ?.footerAddress ||
    LocalStorageFunc.getLastLocationNewOrLastLocationNewForIp()[0]?.recent
      ?.city ||
    "";
  let deliveryType = LocalStorageFunc.getDeliveryType();
  if (deliveryType == "P") {
    return "Takeaway";
  } else if (deliveryType == "DINEIN") {
    return "Dine-in";
  } else {
    let userAddresses = localStorage.userAddresses
      ? tryJsonParse(localStorage.userAddresses)
      : "";
    try {
      let address = {};
      if (
        Array.isArray(userAddresses) &&
        userAddresses.length > 0 &&
        coords?.address_id
      ) {
        address = userAddresses.find(
          (item) => item.address_id == coords.address_id
        );
      } else {
        for (const item of userAddresses) {
          if (
            item.longitude == coords.longitude &&
            item.latitude == coords.latitude
          ) {
            address = item;
          }
        }
      }
      if (Object.keys(address).length > 0) {
        return (
          address.customer_address_name ||
          "Home" ||
          address.footerAddress ||
          address.city
        );
      }
    } catch (err) {}
    if (stores) {
      return (
        stores?.homePageAddress?.topAddress ||
        stores?.city ||
        stores?.footerAddress
      );
    }
    return footerAddress;
  }
};

const getOrderState = ({
  currentOrder,
  orderCurrentState,
  advanceOrder,
  orderStatus,
  deliveryOrderType,
  advanceOrderInProgress,
}) => {
  if (advanceOrder && advanceOrderInProgress) {
    return {
      displayText: OrderStatusCode[deliveryOrderType.deliveryTypeCode][10],
      status: 10,
      showDiscount: true,
      showAdvance: true,
      displayBgClass:
        OrderStatusBgColor[deliveryOrderType.deliveryTypeCode][10],
    };
  }
  if (currentOrder) {
    if (advanceOrder && !advanceOrderInProgress) {
      return {
        displayText: OrderStatusCode[deliveryOrderType.deliveryTypeCode][10],
        status: 10,
        showDiscount: true,
        showAdvance: true,
        displayBgClass:
          OrderStatusBgColor[deliveryOrderType.deliveryTypeCode][10],
      };
    }
    return {
      displayText:
        OrderStatusCode[deliveryOrderType.deliveryTypeCode][orderCurrentState],
      status: orderCurrentState,
      displayBgClass:
        OrderStatusBgColor[deliveryOrderType.deliveryTypeCode][
          orderCurrentState
        ],
    };
  }
  switch (orderStatus) {
    case "PENDING":
      return {
        displayText: "ORDER PLACED",
        status: orderStatus,
        displayBgClass:
          OrderStatusBgColor[deliveryOrderType.deliveryTypeCode][1],
      };
    case "FAILED":
      return {
        displayText: orderStatus,
        status: orderStatus,
        showAdvance: false,
        displayBgClass:
          OrderStatusBgColor[deliveryOrderType.deliveryTypeCode][5],
      };
    case "CANCELLED":
      return {
        displayText: orderStatus,
        status: orderStatus,
        showAdvance: false,
        displayBgClass:
          OrderStatusBgColor[deliveryOrderType.deliveryTypeCode][5],
      };
    case "SUCCESS":
      return {
        displayText:
          ORDER_STATUS_LONG_HISTORY[deliveryOrderType.deliveryTypeCode],
        status: deliveryOrderType.deliveryTypeCode,
        showFavourite: true,
        showDiscount: true,
        displayBgClass:
          OrderStatusBgColor[deliveryOrderType.deliveryTypeCode][9],
      };
    default:
      break;
  }

  return false;
};

const resetLocalStorageOnLogout = () => {
  localStorage.isPaymentModeAvailable = "";
  localStorage.paymentMode = "";
  localStorage.isWalletSelected = "";
  localStorage.totalWalletBalance = "";
  localStorage.selectedAddress = "";
  localStorage.cartItems = JSON.stringify({});
  localStorage.userAddresses = JSON.stringify([]);
  localStorage.addressDetail = JSON.stringify({});
  localStorage.selectedUserAddress = false;
  localStorage.couponCode = "";
};
const resetLocalStorageOnLogin = () => {
  localStorage.isPaymentModeAvailable = "";
  localStorage.paymentMode = "";
  localStorage.isWalletSelected = "";
  localStorage.totalWalletBalance = "";
  localStorage.selectedAddress = "";
  localStorage.NON_LOGGED_IN_SAVED_ADDRESSES = JSON.stringify([]);
  localStorage.userAddresses = JSON.stringify([]);
  localStorage.addressDetail = JSON.stringify({});
  localStorage.selectedUserAddress = false;
};
const checkScrolledToBottom = () => {
  const { innerHeight = 0, scrollY = 0 } = window;
  return innerHeight + scrollY >= document.body.offsetHeight;
};

const convertProviderOptionToPaymentOption = (paymentProvider) => {
  const paymentOption = {
    paymentId: "",
    label: "",
    status: "",
    paymentMode: "",
    img_url: "",
    index: 0,
  };
  paymentOption.paymentId = paymentProvider.providerCode;
  paymentOption.paymentMode = paymentProvider.methodCode;
  paymentOption.label = paymentProvider.providerName;
  paymentOption.img_url = paymentProvider.providerImgUrl;

  if (paymentProvider.card && paymentProvider.card.cardId) {
    paymentOption.card = paymentProvider.card;
  }
  if (paymentProvider.providerStatus == "ENABLED") {
    paymentOption.status = "E";
  } else if (paymentProvider.providerStatus == "DISABLED") {
    paymentOption.status = "D";
  }
  return paymentOption;
};

const getIsVegFoodType = (item) => {
  if (item?.metadataMap?.food_category?.values[0]) {
    return item?.metadataMap?.food_category?.values[0].toLowerCase() === "veg";
  } else if (item?.metadataMap?.foodLabel?.values[0]) {
    return item?.metadataMap?.foodLabel?.values[0].toLowerCase() === "veg";
  } else {
    return false;
  }
};

const getAnalyticKeyValuesFromOrderSummary = (orderSummary) => {
  let itemName = [];
  let itemSku = [];
  let quantity = [];
  let subTotal = [];
  let totalQuantity = 0;
  let dataSummary = {};

  if (orderSummary?.items) {
    orderSummary.items.map((item, index) => {
      itemName[index] = item?.product?.name;
      itemSku[index] = item?.skuId;
      quantity[index] = item?.quantity;
      subTotal[index] = item?.pricePerQty;
      totalQuantity = totalQuantity + item?.quantity;
    });
  }
  if (orderSummary?.paymentSummary?.paymentSummaryItem) {
    orderSummary?.paymentSummary?.paymentSummaryItem.map((item) => {
      dataSummary[item.key] = item.value;
    });
  }

  return {
    itemName,
    itemSku,
    quantity,
    subTotal,
    totalQuantity,
    address: orderSummary?.deliveryAddress,
    ...dataSummary,
  };
};

const handleUrlWithoutStoreId = () => {
  if (
    !checkWindowLocationIncludes(
      getCurrentStoreFolder() + LocalStorageFunc.storeId()
    ) &&
    !isNoRedirectTrue() &&
    !isCurrentlyAtUrl("/location")
  ) {
    setTimeout(() => {
      window.location.href =
        projectBasePathWithFolder +
        getCurrentStoreFolder() +
        LocalStorageFunc.storeId() +
        getUrlQueryString();
    }, 2000);
    return;
  }
};

export default {
  randomnumber,
  groupArrayOfObjectBykey,
  tryJsonParse,
  typeCheckProductItem,
  mergeDeep,
  getDateStringFromTimeStamp,
  getTimeFromTimeStamp,
  getProductSkuId,
  getParentSkuId,
  getProductType,
  getProductCurrentPrice,
  setCookie,
  getCookie,
  deleteCookie,
  isStoreUrlCacheEligible,
  getDomain,
  getCurrentStoreFolder,
  checkWindowLocationIncludes,
  getUrlQueryString,
  areSetsEqual,
  getSearchableText,
  scrollUptoTo,
  gotoElement,
  getProductImages,
  getFormattedDateAdvanceOrder,
  getFormattedTimeAdvanceOrder,
  getFormattedDateTimeAdvanceOrder,
  getCartDataInMenuServiceFormat,
  isDesktop,
  sendToHomepageScreen,
  sendToLoginScreen,
  sendToSearchScreen,
  sendToLocationScreen,
  sendToCartScreen,
  sendToMenuScreen,
  sendToOrderHistory,
  sendToMyAddressPage,
  redirectToLinkRewrite,
  redirectToHomeOrRedirectUrl,
  redirectToOrderHistoryOrRedirectUrl,
  isRedirectedFromCart,
  checkFromAddressPage,
  checkTriggerLocationScreenForAddEditAddress,
  removeAddEditAddressFromStorage,
  checkEditAddressOnLocation,
  getArrayFromObject,
  getAddressObject,
  isCurrentlyAtUrl,
  getAdvanceCardDateStringFromTimeStamp,
  getAdvanceCardTimeStringFromTimeStamp,
  getQueryFromUrl,
  asyncCallWithTimeout,
  getDeviceType,
  isNoRedirectTrue,
  categoryCounter,
  getHamburgerItemIndex,
  getTimePrefixWith,
  categoryCounter,
  sendToOffersScreen,
  osBackButtonFunc,
  appBackButtonFunc,
  convertArrayToObject,
  sendToOrderTracking,
  sendToTnC,
  getInlineNotificationObjectForClientMsg,
  updateOfferUrl,
  getStoreIdFromUrl,
  redirectToPaymentPage,
  getOrderState,
  reloadPage,
  getSkuId,
  getComboSkuId,
  getAdvanceEpochConvertFormat,
  formatAMPM,
  isSeparateMenuVariant,
  addUpdateParam,
  resetLocalStorageOnLogout,
  getAddressAlias,
  sendToThankYouScreen,
  checkScrolledToBottom,
  convertProviderOptionToPaymentOption,
  sendToHelpPage,
  getIsVegFoodType,
  formatTimestampOffer,
  resetLocalStorageOnLogin,
  getAnalyticKeyValuesFromOrderSummary,
  handleUrlWithoutStoreId,
};
